import client from "./client";

export default {

    async getTicketStatuses(filters) {
        return client.parseResponse(await client.get('/ticket-statuses', filters));
    },
    async getTicketStatus(id) {
        return client.parseResponse(await client.get('/ticket-statuses/' + id));
    },
    async createTicketStatus(data) {
        return client.parseResponse(await client.post('/ticket-statuses', data))
    },
    async editTicketStatus(data) {
        return client.parseResponse(await client.put('/ticket-statuses/' + data.id, data))
    }
}
